import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function AddUserIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.00019 9C4.80019 9 3.00019 7.2 3.00019 5V4C3.00019 1.8 4.80019 0 7.00019 0C9.20019 0 11.0002 1.8 11.0002 4V5C11.0002 7.2 9.20019 9 7.00019 9Z" />
        <path d="M5.00019 11C2.54145 11 0.545359 12.6964 0.0953312 15.0059C-0.0103021 15.548 0.447909 16 1.00019 16H8.00019V11H5.00019Z" />
        <path d="M12.0002 10H14.0002V12H16.0002V14H14.0002V16H12.0002V14H10.0002V12H12.0002V10Z" />
      </svg>
    </Icon>
  );
}
